import './Video.scss';

import ReactPlayer from 'react-player/youtube'

const Video = () => {
  return(
    <div className='videoc'>

     
        <ReactPlayer
          
          playing
          controls
          loop
          muted
          width={640}
          height={360}
          className="video"
          url="https://www.youtube.com/watch?v=qUgjtxu4vD0"
          type="video youtube" 

        /> 
        
        
     
    </div>
  )
}

export default Video;

// https://www.youtube.com/watch?v=qUgjtxu4vD0